<template>
  <div class="col-detail-page">
    <div v-if="hasContent">
      <Swiper :banners="colDetail.bannerList" :picUrl="colDetail.picUrl"></Swiper>
      <div class="colTop">
        <div class="colAmount">
          <div>{{ docTotal + '篇文章' }}</div>
          <div v-if="colDetail.hasFocus">{{ colDetail?.subscribeAmount + '人关注' }}</div>
        </div>
        <div>
          <van-button v-if="!isFocus" class="focus" icon="like" plain hairline @click="tofocus(1)">加关注</van-button>
          <van-button v-if="isFocus" class="focused" icon="like" plain hairline @click="tofocus(2)">已关注</van-button>
        </div>
      </div>
      <div class="colContent">
        <div class="colTitle">{{ colDetail.columnistName }}</div>
        <div id="colDescribe" class="colDescribe">
          <a id="descPort" class="descClass">{{ colDetail.columnistDescribe }}</a>
          <!-- <div v-show="shouldShowSeeMore" class="arrow">
            
          </div> -->
          <!-- <span class="arrow" v-show="showSeeMore && shouldShowSeeMore">展开</span>
          <span class="arrow" v-show="showSeeMore && !shouldShowSeeMore">收起</span> -->
          <!-- <van-icon name="arrow-down" v-show="showSeeMore && shouldShowSeeMore" class="arrow" /> -->
          <!-- <van-icon name="arrow-up" v-show="showSeeMore && !shouldShowSeeMore" class="arrow" /> -->
        </div>
      </div>
      <Blocks :blockList="colDetail.blockLineList"></Blocks>
      <ColumnDocs :docs="list" @onLoad="onLoad" :loadings="loading" :finished="finished"></ColumnDocs>
    </div>
    <div v-else>
      <no-content></no-content>
    </div>
  </div>
</template>
<script>
import { isWeixin } from '@/assets/js/utils'
import Swiper from '@/components/Swiper'
import Blocks from '@/components/Blocks'
import ColumnDocs from '@/components/ColumnDocs'
import NoContent from '@/components/NoContent'
import { useLoginTo, getToken } from '@/assets/js/account'
import { JSRegister, JSCallNative } from '@lyh/jsbridge'
export default {
  name: 'ColumnDetail',
  components: {
    Swiper,
    Blocks,
    ColumnDocs,
    NoContent
  },
  data() {
    return {
      uuid: this.$route.query.uuid,
      platformType: this.$route.query.sou == 1 ? 3 : this.$route.query.sou == 2 ? 0 : this.$route.query.sou == 1000 ? 2 : 3,
      colDetail: {},
      isFocus: false,
      pageIdx: 1,
      pages: 0,
      loading: true,
      finished: false,
      share: {},
      list: [],
      docTotal: 0,
      shouldShowSeeMore: false,
      showSeeMore: true,
      hasContent: true,
      desc: ''
    }
  },
  watch: {
    'colDetail.columnistDescribe': {
      handler: function (n1, n2) {
        this.$nextTick(() => {
          // console.log(n1, document.getElementById('colDescribe').offsetHeight);
          if (n1 == '') {
            this.showSeeMore = false
            return
          }

          if (document.getElementById('colDescribe').offsetHeight > 60) {
            const content = document.getElementsByClassName('descClass')[0]
            this.appendMore(content, 2)
            this.shouldShowSeeMore = true
          } else {
            this.showSeeMore = false
          }
        })
      }
    }
  },
  methods: {
    appendMore(ele, line) {
      // console.log('hhh');
      console.log(ele.getClientRects())
      const clientRectList = ele.getClientRects()
      let nextRow
      if (ele.getClientRects()[ele.getClientRects().length - 1].width > 330) {
        nextRow = true
      }
      // console.log(line, clientRectList.length);
      // 如果文本实际行数比给的行数大就溢出了
      if (line < clientRectList.length) {
        ele.classList.add('text-ellipsis')
        // 根据line获取第0行的top到第 line-1 行的bottom的距离就是文本高度
        const height = clientRectList[line - 1].bottom - clientRectList[0].top
        ele.style.height = height + 'px'
        // 添加溢出文本标签及事件
        const more = document.createElement('span')
        more.classList.add('right-bottom')
        more.setAttribute('id', 'moreBtn')
        // more.classList.add('right-a')
        const text1 = document.createTextNode('展开')
        const text2 = document.createTextNode('收起')
        // const text = document.createTextNode('展开')
        more.appendChild(text1)
        ele.appendChild(more)
        let descDom = document.getElementById('colDescribe')
        let descPort = document.getElementById('descPort')
        let height1 = descDom.offsetHeight
        more.addEventListener('click', () => {
          if (this.shouldShowSeeMore == true) {
            this.shouldShowSeeMore = false
            more.removeChild(text1)
            more.appendChild(text2)
            ele.style.height = null

            if (nextRow) {
              console.log('a')
              more.style.bottom = '-20px'
              more.style.backgroundImage = null
              descDom.style.height = null
              descPort.style.overflow = 'inherit'
            }
          } else {
            descDom.style.height = height1
            more.style.bottom = '0px'
            this.shouldShowSeeMore = true
            more.removeChild(text2)
            more.appendChild(text1)
            ele.style.height = height + 'px'
            // console.log(ele.getClientRects());
            descPort.style.overflow = 'hidden'
          }
        })
      }
    },
    async getColumnDetail() {
      const res = await this.$https.getColumnDetail({
        uuid: this.uuid,
        platfromType: this.platformType
      })
      if (res === true) return (this.hasContent = false)
      this.colDetail = res
      this.isFocus = res.isFollows == 0 ? false : true
      this.share = {
        imgUrl: this.colDetail.picUrl,
        link: window.location.origin + window.location.pathname + '?uuid=' + this.uuid + '&sou=999',
        title: this.colDetail.columnistName
      }
      sessionStorage.setItem('share', JSON.stringify(this.share))
      if (isWeixin()) {
        this.$wxshare(this.share)
      }
      JSCallNative('showRightNavigationBarButton')
      JSRegister('shareDoc', (data, callback) => {
        callback({
          param: {
            text: '研值圈',
            title: this.share.title,
            image: this.share.imgUrl,
            url: this.share.link
          }
        })
      })
    },
    async tofocus(n) {
      const login = await useLoginTo(sessionStorage.getItem('LYH_JSLOGIN_SOURCE'))
      if (!login) return
      const res = await this.$https.focusColumn({
        id: this.colDetail.id,
        type: 8,
        isFollow: !this.colDetail.isFollows
      })
      if (typeof res === 'boolean' && !res) return
      this.isFocus = !this.isFocus
    },
    async getColumnDocs() {
      this.loading = true
      this.finished = false
      const res = await this.$https.getColumnDocs({
        uuid: this.uuid,
        type: 8,
        platformType: this.platformType,
        pageIdx: this.pageIdx,
        pageSize: 8
      })
      this.docTotal = res.total
      this.pages = Math.ceil(res.total / 8)
      // console.log(this.pages)
      if (this.pageIdx == 1) {
        this.list = res.list
      } else {
        this.list = [...this.list, ...res.list]
      }
      this.loading = false
      if (res.list.length < 8) this.finished = true
    },
    onLoad() {
      this.loading = true
      this.finished = false
      let that = this
      if (this.pageIdx == this.pages) {
        this.loading = false
        this.finished = true
        return
      }
      ++this.pageIdx
      setTimeout(() => {
        that.getColumnDocs()
      }, 200)
    },
    // textclick() {
    //   if (this.shouldShowSeeMore) {
    //     this.shouldShowSeeMore = false
    //   } else {
    //     this.shouldShowSeeMore = true
    //   }
    // },
    async getToken() {
      await getToken().then(() => {
        this.getColumnDetail()
        this.getColumnDocs()
      })

      
    }
  },
  mounted() {
    // this.getInit()
    if (sessionStorage.getItem('LYH_JSLOGIN_AUTH_KEY')&&!sessionStorage.getItem('LYH_TOKEN')) {
      this.getToken()
      return
    } else {
      this.getColumnDetail()
      this.getColumnDocs()
    }
  }
}
</script>
<style lang="less" scoped>
.col-detail-page {
  max-width: 690px;
  margin: 0 auto;
  height: 100%;
  overflow-y: auto;
}
.colTop {
  margin: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .colAmount {
    display: flex;

    div {
      margin-right: 12px;
      font-size: 12px;
      color: #9898a2;
      line-height: 18px;
    }
  }
}
/deep/.van-button--hairline {
  // border-width: 1px;
  border-radius: 4px;
}

/deep/.van-button--default {
  border: 1px solid #e9eeed;
}

.focus /deep/.van-button__icon {
  color: #dddddd;
}

.focused /deep/.van-button__icon {
  color: #0b9794;
}

/deep/.van-button__text {
  color: #333333;
}

/deep/.van-hairline--surround::after {
  border-width: 0;
}

/deep/.van-button {
  height: 30px;
}

.colContent {
  margin: 16px;
  .colTitle {
    font-size: 18px;
    color: #323236;
    line-height: 26px;
    font-weight: bold;
  }

  .colDescribe {
    // margin-top: 8px;
    padding: 8px 5px 0;
    font-size: 16px;
    color: #323236;
    line-height: 22px;
    // text-align: justify;
    // word-break: break-all;
    // overflow: hidden;
    // position: relative;
    // .descClass {

    // }
    .text-ellipsis {
    }
    .text-ellipsis {
      // font-size: 19px;
      position: relative;
      display: inline-block;
      overflow: hidden;
      /deep/.right-bottom {
        position: absolute;
        display: inline-block;
        padding: 0 10px;
        // font-size: 14px;
        line-height: 21px;
        color: #397cb5;
        background-image: linear-gradient(to right, #ffffffd6, #ffffffff);
        right: -5px;
        bottom: -3px;
        cursor: pointer;
        z-index: 999;
      }
    }
  }
}
</style>
